import gql from 'graphql-tag';

export class CreateDocumentFragments {
  static templateDocument = gql`
    fragment templateDocumentFragment on Document {
      id
      name
      companyName
      isSigning
      isSigningOrder
      isSelfsign
      autoCommentText
      autoCommentEmail
      isAutoComment
      isAutoCommentEmail
      value
      isSigningBiometric
      isSigningInitials
      isSigningForward
      isPrivate
      externalEditorId
      externalEditorType
      uniqueId
      hasWriteAccess
      isSmsReminder
      isReminderSending
      isIdentifyRecipient
      reminderOpened
      reminderOpenedDays
      reminderSigned
      reminderSignedDays
      reminderRepeat
      reminderRepeatDays
      reminderExpiration
      reminderExpirationDays
      isSmsSending
      isScheduledSending
      pages {
        fields {
          fieldType
          fieldSource
        }
      }
      recipients {
        id
      }
    }
  `;
}
